import React from 'react';
import { Layout, Typography } from 'antd';
import { theme } from '../../styles/theme';
import logo from '../../assets/LoanLensLogo.png';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const Header = () => {
  return (
    <AntHeader
      style={{
        background: theme.colors.bgDark,
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: theme.shadows.md,
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <img
          src={logo}
          alt="LoanLens Logo"
          style={{
            height: '40px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
        <Title
          level={3}
          style={{
            margin: 0,
            color: theme.colors.textWhite,
            fontWeight: 600
          }}
        >
          LoanLens
        </Title>
        <span
          style={{
            color: theme.colors.textLight,
            fontSize: '14px',
            marginLeft: '8px'
          }}
        >
          AI Document Intelligence
        </span>
      </div>
    </AntHeader>
  );
};

export default Header;
